<div class="dialog-header">
    <h2>Add Adhoc {{ data.mode == 2 ? 'Approver' : 'Reviewer' }}</h2>
    <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<mat-divider></mat-divider>
<form [formGroup]="teamForm" (ngSubmit)="addTeam()">
    <mat-dialog-content>
        <div class="w-100">
            <div class="dense-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Select User</mat-label>
                    <mat-select formControlName="userInfo" [errorStateMatcher]="matcher">
                        <mat-option *ngFor="let user of remainingUsers" [value]="user">{{ user.firstName +
                            (user.middleName ? ' ' + user.middleName + ' ' : ' ') + user.lastName }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="teamForm.get('userInfo').hasError('required')">
                        User is required
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="dense-2 mt-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Sequence No</mat-label>
                    <input matInput formControlName="sequenceNo" type="number" autocomplete="off"
                        [errorStateMatcher]="matcher" />
                    <mat-error *ngIf="teamForm.get('sequenceNo').hasError('required')">
                        Sequence No is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-raised-button mat-dialog-close color="primary" mat-dialog-close [disabled]="isLoading"
            class="outlined-btn">Cancel</button>
        <button color="accent" mat-raised-button class="ml-3" [disabled]="isLoading" type="submit">Submit
            <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        </button>
    </mat-dialog-actions>
</form>